import topic from "@api/topic";
export const iqcrAPI = {
    get_iqcrs: topic.iqcrTopic + '/get_iqcrs'
}